import TranslationsConfigType from './translationType';

const nbTranslations: TranslationsConfigType = {
    tryAgain: 'Prøv igjen',
    showLess: 'Vis mindre',
    showMore: 'Vis mer',
    cancel: 'Avbryt',
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        ohNo: 'Å nei!',
        oops: 'Oj sann!',
        timeoutMessage: 'Vi beklager, det tok litt lenger tid enn vi hadde tenkt. Du må gjerne prøve igjen',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
    },
    header: 'Hei på deg',
    buttonText: 'Knappen',
    ekstraText: 'Todo',
    ok: 'Ok',
    comparisonTableButtonTexts: {
        digitaltProdukt: 'Sjekk pris og kjøp forsikring',
        ikkeDigitaltProdukt: 'Spør oss om pris',
    },
    comparisonTableLinkTexts: {
        vilkarPdf: 'Fullstendige vilkår (pdf)',
        produktinformasjonPdf: 'Produktinformasjon (pdf)',
    },
    uforekalkulatorButtonText: {
        kontaktMegButton: 'Kontakt meg om uføreforsikring',
    },
};

export default nbTranslations;
